import React from "react";

const MuseumofMystiqueFaq = () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [{
                            "@type": "Question",
                            "name": "Do I need to book tickets in advance?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Online booking is helpful, especially during weekends or peak tourist days, but it's not required. You can also buy tickets at the counter, depending on availability when you arrive."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Is it just for kids, or will adults enjoy it too?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "The experience is fun for all age groups. While kids love the playfulness, adults often find the illusions just as fascinating and end up clicking as many photos as the kids do."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Is there anything that moves suddenly or could startle someone?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Nope! All exhibits are safe, still, and easy-going. There are no sudden movements, loud sounds, or anything designed to scare or startle visitors. It is just optical fun and visual surprises."
                            }
                        }]
                    }
                )
            }}
        />
    </React.Fragment>
);
export default MuseumofMystiqueFaq;